import type { TourConfig } from '../../types/tour.types'

// Preferred Titles LIST page (route `PreferredTitles`). The create FORM has its own tour
// (preferred-title.tour.ts, route `PreferredTitleCreate`). Anchors: `data-tour` on the header
// buttons and the existing `.pt-table-card` class.
const preferredTitlesTour: TourConfig = {
  id: 'preferred-titles',
  title: 'Manage preferred titles',
  module: 'Settings',
  routeName: 'PreferredTitles',
  order: 8,
  autoStart: true,
  featureFlag: 'enablePreferredTitles',
  steps: [
    {
      id: 'intro',
      title: 'Reusable rules for who you export',
      body: 'A **preferred title** is a saved rule for the people you care about — the job titles, departments, levels and countries to prioritise. Build them here once and apply them on exports so you always reach the right contacts.',
    },
    {
      id: 'create',
      target: '[data-tour="pt-list-create"]',
      placement: 'bottom',
      // Hidden on an empty list (an empty-state CTA is shown instead), so skip if absent.
      optional: true,
      title: 'Create a preferred title',
      body: 'Start a new rule and define the **titles, departments, contact levels and countries** to prioritise. We\'ll walk you through the form when you open it.',
    },
    {
      id: 'table',
      target: '.pt-table-card',
      placement: 'top',
      title: 'Your saved rules live here',
      body: 'Every preferred title you create shows up in this list. **Search by name**, then **Edit** to refine it or **Remove** to delete it — each one is available to apply when you export.',
    },
    {
      id: 'help',
      target: '[data-tour="pt-list-help"]',
      placement: 'bottom',
      title: 'Not sure how it works?',
      body: '**How To Use** opens a quick explainer of how preferred titles shape your exports — handy the first time you set one up.',
    },
  ],
}

export default preferredTitlesTour
